const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

export const MENTION_PATTERNS = {
  user: new RegExp(`<@(${UUID})>`, 'g'),
  role: new RegExp(`<@&(${UUID})>`, 'g'),
  channel: new RegExp(`<#(${UUID})>`, 'g'),
};

/** Removes fenced and inline code so mentions and links inside code are ignored. */
export function stripCode(content: string): string {
  return content.replace(/```[\s\S]*?```/g, ' ').replace(/`[^`\n]*`/g, ' ');
}

export interface ParsedMentions {
  users: string[];
  roles: string[];
  channels: string[];
  everyone: boolean;
  here: boolean;
}

export function parseMentions(content: string): ParsedMentions {
  const text = stripCode(content);
  const collect = (re: RegExp) => [...new Set([...text.matchAll(re)].map((m) => m[1]!))];
  return {
    users: collect(MENTION_PATTERNS.user),
    roles: collect(MENTION_PATTERNS.role),
    channels: collect(MENTION_PATTERNS.channel),
    everyone: /(^|[^\w`])@everyone\b/.test(text),
    here: /(^|[^\w`])@here\b/.test(text),
  };
}

const URL_RE = /<?(https?:\/\/[^\s<>"'`]+[^\s<>"'`.,;:!?)\]}])>?/gi;

/** Links that should get a preview. Links wrapped in <angle brackets> are suppressed. */
export function extractEmbeddableUrls(content: string, max = 3): string[] {
  const text = stripCode(content).replace(/\|\|[\s\S]*?\|\|/g, ' ');
  const urls: string[] = [];
  for (const match of text.matchAll(URL_RE)) {
    const whole = match[0];
    if (whole.startsWith('<') && whole.endsWith('>')) continue;
    const url = match[1]!;
    if (!urls.includes(url)) urls.push(url);
    if (urls.length >= max) break;
  }
  return urls;
}

export function containsLink(content: string): boolean {
  return /https?:\/\/\S+/i.test(content);
}
